enum EnrollmentStatus {
  Enrolled = '1',
  NotSelected = '0',
  Waived = '-1',
  Declined = '-2',
}

export default EnrollmentStatus;
